module.exports = __webpack_public_path__ + "static/media/inspiron_poster.8ced4230.png";